import React, {memo, useEffect, useRef, useState} from "react";
import {Button, Form, message, Modal} from "antd";
import {
  CollegeRecommend,
  CollegeRecommendParams,
  PostMessageEvent,
  SubjectInfo,
  TotalType,
  UserInfo,
} from "@/pages/SchoolDiagnoseReport/type";
import {fetchReportDetail, reportGenerate, reportPreview,} from "@/pages/SchoolDiagnoseReport/api";
import "./index.less";
import {useSearchParams} from "react-router-dom";
import UserInformation from "@/pages/SchoolDiagnoseReport/components/UserInfo";
import SchoolRecommend from "@/pages/SchoolDiagnoseReport/components/SchoolRecommend";
import {md5SchoolDiagnoseSign} from "@/utils/md5";
import SubjectScore from "@/pages/SchoolDiagnoseReport/components/SubjectScore";

const ENV = ENV_CUSTOM;


type Precollege = {
  recommend?: Array<CollegeRecommend>;
  notRecommend?: Array<CollegeRecommend>;
}

const SchoolDiagnoseReport: React.FC = () => {
  const [search] = useSearchParams();
  const [userInfo, setUserInfo] = useState<UserInfo>({});

  const [subjectAndScoreList, setSubjectAndScoreList] = useState<
    Array<SubjectInfo>
  >([]);
  const [collegeRecommendList, setCollegeRecommendList] = useState<
    Array<CollegeRecommend>
  >([]);

  const precollege = useRef<Precollege>({notRecommend:[], recommend:[]})

  //是否选择智能推荐院校
  const [recommend, setRecommend] = useState<boolean>(true);
  //左侧iframe需要用到的sn
  const [sn, setSn] = useState<string>(search.get("sn"));
  const SNRef = useRef<string>(search.get("sn"));
  const preTotal = useRef<number>();

  //不需要深拷贝， 解决输入框change时需要变更precollege
  // useEffect(() => {
  //   if(recommend) setCollegeRecommendList([...precollege.current.recommend])
  //   else setCollegeRecommendList([...precollege.current.notRecommend])
  // }, [recommend])


  //校验所有提升空间是否为空
  const checkImproveScoreIsExistNull = () => {
    return subjectAndScoreList.some((item: SubjectInfo) => {
      return item.subject_id && item.improve_score === null;
    });
  };

  //校验主攻科目是否至少选择了一个
  const checkMainSubjectIsExist = () => {
    return subjectAndScoreList.some((item: SubjectInfo) => {
      return item.subject_id && item.is_main_attack;
    });
  };

  //点击重置
  const handleReset = () => {
    window.location.reload();
  };

  //点击取消
  const handleCancel = () => {
    postMessage(PostMessageEvent.CANCEL)
  }
  //生成报告成功
  const handleOk = () => {
    postMessage(PostMessageEvent.OK)
  }

  const postMessage = (event:PostMessageEvent, from:string = 'academicDiagnosisEdit') => {
    console.log(event)
    window?.parent?.postMessage(
        JSON.stringify({
          from: from,
          event: event,
        }), '*'
    );
  }

  //点击生成报告
  const handleGenerateReport = () => {
    if (checkImproveScoreIsExistNull()) {
      message.error("请填写提升空间");
      return;
    }
    if (!checkMainSubjectIsExist()) {
      message.error("请选择主攻科目");
      return;
    }
    Modal.confirm({
      title: "是否确认生成报告?",
      cancelText: "否",
      okText: "是",
      cancelButtonProps: {
        danger: true,
      },
      okButtonProps: {
        danger: true,
      },
      onOk: fetchReportGenerate,
    });
  };

  //点击预览
  const handlePreview = async () => {
    if (checkImproveScoreIsExistNull()) {
      message.error("请填写提升空间");
      return;
    }
    if (!checkMainSubjectIsExist()) {
      message.error("请选择主攻科目");
      return;
    }
    fetchReportPreview();
  };

  //计算当前总分
  const getTotal = (subjectAndScoreList: Array<SubjectInfo>) => {
    const total: TotalType = { score: 0, full_score: 0, improve_score: 0 };
    subjectAndScoreList.forEach((item: SubjectInfo) => {
      total.full_score += item.full_score;
      total.score += item.score;
      total.improve_score += item.improve_score ? item.improve_score : 0;
    });
    return total;
  };

  const getParams = () => {
    let params: CollegeRecommendParams;
    let isTotalChange = false;
    if (
      preTotal.current !==
      subjectAndScoreList[subjectAndScoreList.length - 1].improve_score
    ) {
      isTotalChange = true;
    }
    if (!recommend || (recommend && !isTotalChange)) {
      params = {
        edited_subject_info: [],
        cur_college_recommend: recommend ? precollege.current.recommend[0] : collegeRecommendList[0],
        target_college_recommend: recommend ? precollege.current.recommend[1] : collegeRecommendList[1],
        sn: SNRef.current,
      };
    } else {
      params = {
        edited_subject_info: [],
        sn: SNRef.current,
      };
    }

    subjectAndScoreList.forEach((item: SubjectInfo, index: number) => {
      if (index !== subjectAndScoreList.length - 1) {
        params.edited_subject_info.push({ ...item });
      }
    });
    return params;
  };

  const fetchReportGenerate = async () => {
    const res = await reportGenerate({
      body: { ...getParams() },
      query: { ...md5SchoolDiagnoseSign() },
    });
    if (res.code === 0) {
      preTotal.current =
        subjectAndScoreList[subjectAndScoreList.length - 1].improve_score;
      Modal.success({
        title: "报告生成成功",
        onOk: handleOk,
        okType: "danger",
        okText: "完成",
      });
    }
  };
  const fetchReportPreview = async () => {
    const res = await reportPreview({
      body: { ...getParams() },
      query: { ...md5SchoolDiagnoseSign() },
    });
    if (res.code === 0) {
      //如果是智能推荐 才变更总recommend;
      if(recommend)
        preTotal.current =
          subjectAndScoreList[subjectAndScoreList.length - 1].improve_score;
      const { cur_college_recommend, target_college_recommend } = res.data;
      setCollegeRecommendList([
        { ...cur_college_recommend },
        { ...target_college_recommend },
      ]);
      if(recommend) {
        precollege.current.recommend = [
          { ...cur_college_recommend },
          { ...target_college_recommend },
        ]
      }else {
        precollege.current.notRecommend = [
          { ...cur_college_recommend },
          { ...target_college_recommend },
        ]
      }
      setSn(res.data?.sn);
    }
  };

  //获取报告数据
  const getReportDetail = async (sn: string) => {
    const res = await fetchReportDetail({
      body: { sn },
      query: { ...md5SchoolDiagnoseSign() },
    });
    if (res.code === 0) {
      const { data } = res;
      // 处理用户信息
      setUserInfo({
        stu_name: data?.stu_name,
        area_name: data?.area_name,
        year: data?.year,
        grade: data?.grade,
      });
      // 处理院校推荐
      const recommendList = [{ ...data.cur_college_recommend }].concat([
        { ...data.target_college_recommend },
      ]);
      setCollegeRecommendList([...recommendList]);
      precollege.current.recommend =[{ ...data.cur_college_recommend }].concat([
        { ...data.target_college_recommend },
      ]);
      precollege.current.notRecommend = [{ ...data.cur_college_recommend }].concat([
        { ...data.target_college_recommend },
      ]);
      //处理科目分数
      const subjectList: Array<SubjectInfo> = [...data?.edited_subject_info];
      //处理总分
      const total: TotalType = getTotal(data?.edited_subject_info);
      preTotal.current = total.improve_score;
      subjectList.push({ ...total, subject_name: "总和" });
      setSubjectAndScoreList([...subjectList]);
    } else {
      message.error(res.msg);
    }
  };
  const checkIsExistSN = () => {
    if (sn === null) {
      message.error("缺少必要参数sn");
    }
  };

  const checkIsIframe = () => {
   //生产环境域名不一致
   //  if (window.self.frameElement && window.self.frameElement.tagName == "IFRAME" || search.get('test') == '1') {
   //  if (window.btoa(search.get('sn')) === search.get('rule') || search.get('test') == '1') {
    if (window.top !== window || search.get('test') == '1') {
      console.log('---------------111')
      checkIsExistSN();
      getReportDetail(sn);
    }else {
      message.error("打开方式有误！");
    }
  }


  useEffect(() => {
    checkIsIframe()
  }, []);

  return (
    <div className="school_diagnose">
      <div className="school_diagnose__left">
        <iframe
            src={ENV === 'production' ? `https://knowledge.xiwang.com/school-diagnose/#/DiagnosisReport?sn=${sn}`:`https://teacherdesk-test.xiwang.com/school-diagnose/#/DiagnosisReport?sn=${sn}`}
            width="375px"
          height="667px"
          key={sn} //动态刷新
        ></iframe>
      </div>

      <div className="school_diagnose__right">
        <Form
          name="basic"
          validateTrigger={"onSubmit"}
          onFinish={() => {}}
          onFinishFailed={() => {}}
          autoComplete="off"
        >
          <UserInformation userInfo={userInfo}></UserInformation>
          <div className="school_diagnose__right-underline"></div>
          <SubjectScore
            subjectAndScoreList={subjectAndScoreList}
            setSubjectAndScoreList={setSubjectAndScoreList}
            FormItem={Form.Item}
          ></SubjectScore>
          <div className="school_diagnose__right-underline"></div>
          <SchoolRecommend
            setCollegeRecommendList={setCollegeRecommendList}
            setRecommend={setRecommend}
            collegeRecommendList={collegeRecommendList}
            recommend={recommend}
          ></SchoolRecommend>
          <div className="school_diagnose__right-underline"></div>
          <div className="school_diagnose__operate-wrapper">
            <Form.Item>
              <Button
                className="school_diagnose__operate"
                htmlType="submit"
                onClick={handlePreview}
              >
                预览
              </Button>
            </Form.Item>
            <Button className="school_diagnose__operate" onClick={handleReset}>
              重置
            </Button>
            <Button className="school_diagnose__operate" onClick={handleCancel}>取消</Button>
            <Form.Item>
              <Button
                htmlType="submit"
                className="school_diagnose__operate-end"
                onClick={handleGenerateReport}
              >
                生成报告
              </Button>
            </Form.Item>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default memo(SchoolDiagnoseReport);
